// Filename: uiimg.js
// Timestamp: 2017.12.06-17:22:04 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const img = cfg.h(ndx, nd).img
  const src = subj.src
  const alt = subj.alt

  return (
    img('.:ui-img', {
      src,
      alt
    })
  )
}

export default {
  type: 'uiimg',
  xvnode
}
